import React from "react";
import './MposLoader.scss';
import { Dialog } from "@material-ui/core";

export class MposLoader extends React.Component {
    render(){
        return (
            // @ts-ignore
            <Dialog fullScreen disableBackdropClick disableEscapeKeyDown open={this.props.show} className={"result-dialog-full-screen"}>
                <div className={"loading-spinner-container"}>
                    <div className={"loading-spinner-content"}>
                        <div className={"spinner-title"}>
                            Attendi qualche secondo,<br/>
                            stiamo verificando i tuoi dati
                        </div>
                        <div className={"spinner-layers"}>
                            <div className={"spinner"}>
                                <div className={"spin spin05"}/>
                            </div>
                            <div className={"spinner"}>
                                <div className={"spin spin04"}/>
                            </div>
                            <div className={"spinner"}>
                                <div className={"spin spin03"}/>
                            </div>
                            <div className={"spinner"}>
                                <div className={"spin spin02"}/>
                            </div>
                            <div className={"spinner"}>
                                <div className={"spin spin01"}/>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        );
    }
}